var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.322 381.322",
    width: 382,
    height: 382,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.582 6.053v369.2a6.05 6.05 0 0 1-3.534 5.503 6 6 0 0 1-2.518.55c-1.42 0-2.838-.503-3.96-1.472l-95.907-82.84-95.912 82.84c-1.797 1.554-4.327 1.92-6.475.922-2.148-.987-3.535-3.127-3.535-5.503V6.053C84.74 2.704 87.445 0 90.793 0H290.53a6.05 6.05 0 0 1 6.052 6.053z"
  })));
}

export default __webpack_public_path__ + "media/e870b3dd.svg";
export { SvgBookmark as ReactComponent };